// The assistant's routes (src/lib/assistant/server.js), from the browser. Shown only when the site
// has it (NEXT_PUBLIC_ASSISTANT=1).
import { extensionOn } from "../../lib/extensions/registry";

export const assistantOn = () => extensionOn("assistant");

export class AssistantError extends Error {
  constructor(status, message) { super(message); this.status = status; }
}

// A turn: the message (with what's on the page) sent, and the reply's events handed to `onEvent`
// as they stream in (see src/lib/assistant/service.js).
export const streamTurn = (body, onEvent, options) => streamEvents("/api/assistant/chat", body, onEvent, { ...options, failure: "The assistant couldn't answer that." });

// A POST whose answer is server-sent events (an assistant's turn, a module's run), each handed to
// `onEvent` as it arrives. A refusal before it starts throws, with its status.
export async function streamEvents(url, body, onEvent, { signal, failure = "That didn't work." } = {}) {
  const response = await fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), signal });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new AssistantError(response.status, payload.error || failure);
  }
  const reader = response.body.getReader(), decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    let end;
    while ((end = buffer.indexOf("\n\n")) >= 0) {
      const data = buffer.slice(0, end).split("\n").filter((line) => line.startsWith("data: ")).map((line) => line.slice(6)).join("\n");
      buffer = buffer.slice(end + 2);
      if (!data) continue;
      let event;
      try { event = JSON.parse(data); } catch { continue; }
      onEvent(event);
    }
    if (done) return;
  }
}
